import { DATA } from "./data";

export class DataService {
  app: any;
  database: any;
  translations: any;
  locale: string;
  def: any;

  data: any;
  isDataLoaded: boolean;
  constructor() {
    let w: any = window;
    this.locale = w.__LOCALE__;

    this.isDataLoaded = false;
  }

  load() {
    return new Promise((res, rej) => {
      res(DATA);
    });
  }

  getByKey = (key: string) => {
    return this.data[key];
  };

  getNavBar = () => {
    return this.data.navBar;
  };

  getLocale = () => {
    return this.data.locale;
  };

  getData() {
    return this.data;
  }
}

const DATA_SERVICE = new DataService();

export default DATA_SERVICE;
